import { useEffect, useState } from "react";
import "./Header.css";
import searchIcon from "../../assets/searchIcon.svg";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  InputAdornment,
  // Modal,
} from "@mui/material";
import ProfileSettings from "../../Pages/ProfileSettings";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../CustomModel/CustomModel";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import Guidelines from "../Guidelines/Guidelines";
import TextField from "../TextField";
import bellIcon from "../../assets/redesign/bell.svg";
import { useCompanyData } from "../../context/MasterContextProvider";
import { REGIONS } from "../../constants/regions";
import { useRegion } from "../../context/RegionContext";

const Header = () => {
  // const [statsData, setStatsData] = useState<any>();
  const { region } = useRegion();

  const [openHelp, setOpenHelp] = useState(false);

  const handleHelpClose = () => {
    setOpenHelp(false);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const apiUrl = `${
      import.meta.env.VITE_BASE_URL
    }/clients/company/profile/get/${localStorage.getItem(
      "companyId"
    )}/dashboardInfo`;
    if (!localStorage.getItem("userId")) {
      navigate("/login");
      // navigate("/");
      return;
    }
    const headers = {
      Authorization: localStorage.getItem("userId"),
    };
    axios
      .get(apiUrl, { headers })
      .then(() => {
        // setStatsData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [localStorage.getItem("userId"), navigate]);

  // const lastname = localStorage.getItem("lastname") || '';

  const handleCloseProfileDrawer = () => {
    setOpenDrawer(false);
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleClick = () => {
    navigate("/dashboard/settings");
  };

  const handleLogoutConfirm = () => {
    setModalOpen(false);
    localStorage.clear();
    navigate("/");
  };

  const location = useLocation();
  const path = location.pathname;

  const getPage = () => {
    if (path === "/dashboard/jobsposted") return "Jobs";
    else if (path === "/dashboard/applications") return "Applications";
    else if (path === "/dashboard/placements") return "Placements";
    else if (path === "/searchcv")
      return `Search ${region === REGIONS.SA ? "Saudi" : "Emirati"} Talents`;
    else if (path === "/dashboard/profile") return "Profile";
    else if (path === "/dashboard/settings") return "Settings";
    else return "Dashboard";
  };
  const getDescription = () => {
    if (path === "/dashboard/jobsposted")
      return "Detailed information about your jobs";
    else if (path === "/dashboard/applications")
      return "Detailed information about your applications";
    else if (path === "/dashboard/placements")
      return "Detailed information about your placements";
    else if (path === "/dashboard/profile")
      return "Detailed information about your talent";
    else if (path === "/dashboard/settings")
      return "Detailed information about your company";
    else if (path === "/searchcv")
      return "Detailed information about your Search Database";
    else return "Detailed information about your dashboard";
  };

  const { company } = useCompanyData();

  const [searchQuery, setSearchQuery] = useState("");

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && searchQuery.trim() !== "") {
      // Navigate to /searchcv with searchQuery as query parameter
      navigate(`/searchcv?searchQuery=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <div>
      <header className="main_header_container">
        <div className="header-box">
          <div className="header_content_wrapper">
            <span className="header-title">{getPage()}</span>
            <span className="header-desc">{getDescription()}</span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // width: "290px",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <TextField
              label=""
              className="disable_in_mobile"
              fullWidth
              placeholder="Search for candidates"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
              onKeyDown={handleKeyDown}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} />
                  </InputAdornment>
                ),
              }}
            />

            <div className="profile-box">
              <div className="profile">
                <IconButton size="small">
                  <img src={bellIcon} />
                </IconButton>
              </div>
            </div>
            <div className="profile-box">
              <div onClick={handleClick} className="profile">
                <IconButton size="small">
                  {company?.companyLogo ? (
                    <img src={company.companyLogo} className="company_logo" />
                  ) : (
                    <Avatar
                      sx={{
                        height: "35px",
                        width: "35px",
                      }}
                      src={""}
                      alt="profile"
                    />
                  )}
                </IconButton>
              </div>
            </div>
            <Guidelines open={openHelp} handleClose={handleHelpClose} />

            <Drawer
              anchor="right"
              open={openDrawer}
              onClose={handleCloseProfileDrawer}
              // PaperProps={{
              //   sx: { width: 400 },
              // }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingLeft: "5%",
                  paddingRight: "3%",
                  paddingTop: "10%",
                }}
              >
                <h1 className="profile">Profile Settings</h1>
                <IconButton onClick={handleCloseProfileDrawer}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <ProfileSettings />
            </Drawer>
          </div>
        </div>
      </header>

      <CustomModal
        body="Do you want to logout"
        message="Are you sure?"
        primaryBtnLabel="Yes"
        secondaryBtnLabel="No"
        onPrimary={handleLogoutConfirm}
        open={modalOpen}
        onSecondary={() => setModalOpen(false)}
        hideSecondaryBtn={false}
        modalStyle={{ backgroundColor: "white" }}
        modalSize="small"
        messageTypographyStyle={{
          font: "normal normal bold 20px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        bodyTypographyStyle={{
          font: "normal normal  18px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        playAnimation={false}
        buttonStyles={{ display: "flex", justifyContent: "flex-end" }}
      />
    </div>
  );
};

export default Header;
